import cx from "classnames"
import styles from "./headingLabel.module.css"

function HeadingLabel({ className = "", children }) {
  return <span className={cx(styles.headingLabel, className)}>{children}</span>
}

export default HeadingLabel
